<template>
    <div>
        <DispensacaoForm
            :form="form"
            :model="model"
            @save="handleSave()"
            ref="DispensacaoForm"
        />
    </div>
</template>

<script>
import DispensacaoForm from '@/components/almoxarifado/dispensacao-materiais/components/dispensacao/Form'

export default {
    components: {
        DispensacaoForm
    },
    methods: {
        validate() {
            return this.$refs.Dispensacao.validate()
        },
        save() {
            this.$refs.DispensacaoForm.save()
        },
        handleSave() {
            this.$emit('save')
        },
        editItem(item) {
            this.$refs.DispensacaoForm.editItem(item)
        }
    },
    props: {
        form: { type: Object, default: null },
        model: { type: Object, default: null },
    }
}
</script>